export default {"src":"/_next/static/media/achievement-bg.1d94c746.svg","height":162,"width":394,"blurWidth":0,"blurHeight":0};